import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIsMobileDevice } from '../../../../hooks';
import { TDispatch } from '../../../../redux';
import { ETopBetsStatus, reloadTopBets } from '../../../../redux/reducers';
import { selectTopBetsRequestDateTime, selectTopBetsStatus } from '../../../../selectors/topBets';
import { BetLeaders } from './BetLeaders';

export const BetLeadersContainer = () => {
  const isMobile = useIsMobileDevice();

  const requestTime = useSelector(selectTopBetsRequestDateTime);
  const status = useSelector(selectTopBetsStatus);

  const dispatch = useDispatch<TDispatch>();

  const handleReloadClick = React.useCallback(() => {
    dispatch(reloadTopBets());
  }, [dispatch]);

  const isLoading = status === ETopBetsStatus.pending;

  return (
    <BetLeaders isMobile={isMobile} isLoading={isLoading} requestTime={requestTime} onReloadClick={handleReloadClick} />
  );
};
